/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0f778c83bc8082fc596ba12347f14cf9>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "AiGenerativeRemove".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for remove filler words functionality in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const AiGenerativeRemoveIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "AiGenerativeRemoveIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.5 0a.75.75 0 0 1 .706.494l.535 1.468a.5.5 0 0 0 .298.298l1.468.535a.75.75 0 0 1 0 1.41l-1.468.535a.5.5 0 0 0-.298.299l-.535 1.467a.75.75 0 0 1-1.41 0L11.26 5.04a.5.5 0 0 0-.298-.299l-1.467-.535a.75.75 0 0 1 0-1.41l1.467-.535a.5.5 0 0 0 .298-.298l.536-1.468A.75.75 0 0 1 12.5.001M5.4 6.194a2 2 0 0 1 2.791-.034l2.131 2.025a2 2 0 0 1 .04 2.86L7.2 14.226l-.014.014-1.263 1.206A2 2 0 0 1 4.541 16h-.91a2 2 0 0 1-1.305-.484l-.124-.107-.042-.038-1.556-1.557a2 2 0 0 1 0-2.828L2.279 9.31zm1.758 1.053a.5.5 0 0 0-.698.009L3.87 9.84l2.795 2.794L9.3 9.986a.5.5 0 0 0-.01-.715zm-1.564 6.44L2.81 10.9l-1.146 1.145a.5.5 0 0 0 0 .708l1.537 1.536.103.09a.5.5 0 0 0 .326.12h.91a.5.5 0 0 0 .346-.139zM16 16H9v-1.5h7z" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
AiGenerativeRemoveIcon.displayName = 'AiGenerativeRemoveIcon';
var _default = exports.default = AiGenerativeRemoveIcon;